import * as React from 'react'
import { cn } from '../utils/cn'
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  variant?: 'default' | 'line'
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, variant = 'default', ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          variant === 'default' &&
            'text-input flex w-full rounded-md border border-input bg-transparent px-4 py-3 font-light transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:border-destructive-foreground aria-[invalid=true]:focus-within:border-primary',
          variant === 'line' &&
            'text-input flex w-full border-b border-input bg-transparent px-1 py-1 font-light transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:border-primary focus-visible:outline-none  disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:border-destructive-foreground aria-[invalid=true]:focus-within:border-primary',
          // variant === 'line' &&
          //   'text-input flex w-full border-b border-input bg-transparent px-1 py-3 font-light transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:border-[hsl(var(--ring))] focus-visible:outline-none  disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:border-destructive-foreground aria-[invalid=true]:focus-within:border-primary',
          className,
        )}
        // className={cn(
        // 	'flex w-full px-4 py-3 font-light transition-colors bg-transparent border rounded-md border-input text-input leading-input file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
        // 	className
        // )}
        // className={
        // 	'flex w-full px-4 py-3 font-light transition-colors bg-transparent border rounded-md border-input text-input leading-input file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50'
        // }
        // className={cn(
        // 	'flex h-9 w-full rounded-md border border-input  px-4 py-3 text-sm text-input leading-input shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 bg-transparent',
        // 	className
        // )}
        ref={ref}
        {...props}
      />
    )
  },
)
Input.displayName = 'Input'

export { Input }
// import * as React from 'react'

// import { cn } from '../utils/cn'

// export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

// const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => {
// 	return (
// 		<input
// 			type={type}
// 			className='flex w-full px-4 py-3 font-light transition-colors bg-transparent border rounded-md border-input text-input leading-input file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50'
// 			// className={cn(
// 			// 	'flex h-9 w-full rounded-md border border-input  px-4 py-3 text-sm text-input leading-input shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 bg-transparent',
// 			// 	className
// 			// )}
// 			ref={ref}
// 			{...props}
// 		/>
// 	)
// })
// Input.displayName = 'Input'

// export { Input }
